import { SitesService } from '@/services/sitesService';

// Mapping des sites vers leurs URLs SEO-friendly basé sur les vraies données Supabase
export const siteUrlMapping: Record<string, string> = {
  // Sites existants - mapping par nom de site (basé sur les vraies données)
  'belle-recyclage': '/site/belle-recyclage/sainte-radegonde',
  'briane-jean-recuperation': '/site/briane-jean-recuperation/ledergues', 
  'carmausine-de-recuperation': '/site/carmausine-de-recuperation/carmaux',
  'casse-auto-du-bassin': '/site/casse-auto-du-bassin/viviez',
  'fabrude-recyclage': '/site/fabrude-recyclage/saint-paul-des-landes',
  'lescout-recyclage': '/site/lescout-recyclage/lescout',
  'profit-recyclage': '/site/profit-recyclage/beauchamp',
  'rm-recyclage': '/site/rm-recyclage/coren',
  
  // Mapping par UUID (à partir des vraies données Supabase)
  '7f40171c-4507-4cec-95d5-d621b4a4deea': '/site/belle-recyclage/sainte-radegonde', // Bellé recyclage
  '1bbf24f6-47e9-49e6-acce-ee49c487c3e3': '/site/briane-jean-recuperation/ledergues', // Briane Jean
  'f151588c-e129-4bfc-be02-69240ed00223': '/site/carmausine-de-recuperation/carmaux', // Carmausine
  '5241f80d-9340-4513-b210-5bc29e1cb54e': '/site/casse-auto-du-bassin/viviez', // Casse Auto
  '6276bdc7-5aac-477c-8859-a48b84267d89': '/site/fabrude-recyclage/saint-paul-des-landes', // Fabrude
  'd0e83661-3827-4de3-91b5-24b65fe092f9': '/site/lescout-recyclage/lescout', // Lescout
  'd6d6fc33-504b-438d-8b93-209e4f218772': '/site/profit-recyclage/beauchamp', // Profit
  'f73b630e-b9c6-4e63-b7c6-04af2ff572c3': '/site/rm-recyclage/coren', // RM Recyclage
};

// Fonction pour générer l'URL SEO-friendly d'un site
export const generateSiteUrl = (siteName: string, city: string): string => {
  const siteSlug = siteName
    .toLowerCase()
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  
  const citySlug = city
    .toLowerCase()
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  
  return `/site/${siteSlug}/${citySlug}`;
};

// Fonction pour obtenir l'URL d'un site à partir de son ID ou nom (synchrone)
export const getSiteUrl = (siteIdOrName: string, siteName?: string, city?: string): string => {
  // Si on a le nom du site et la ville, générer directement l'URL
  if (siteName && city) {
    return generateSiteUrl(siteName, city);
  }
  
  // Vérifier dans le mapping existant (ID ou nom)
  const mappedUrl = siteUrlMapping[siteIdOrName];
  if (mappedUrl) {
    return mappedUrl;
  }
  
  // Essayer de générer à partir du nom de site
  const siteSlug = siteIdOrName
    .toLowerCase()
    .replace(/[àáâãäå]/g, 'a')
    .replace(/[èéêë]/g, 'e')
    .replace(/[ìíîï]/g, 'i')
    .replace(/[òóôõö]/g, 'o')
    .replace(/[ùúûü]/g, 'u')
    .replace(/[ç]/g, 'c')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
    
  // Vérifier si on a un mapping pour ce slug
  const slugMappedUrl = siteUrlMapping[siteSlug];
  if (slugMappedUrl) {
    return slugMappedUrl;
  }
  
  // Fallback vers l'ancienne structure si pas de mapping
  return `/sites/${siteSlug}`;
};

// Mapping inverse pour les redirections basé sur les vraies données
export const legacySiteMapping: Record<string, string> = {
  // UUIDs vers nouvelles URLs (vraies données Supabase)
  '7f40171c-4507-4cec-95d5-d621b4a4deea': '/site/belle-recyclage/sainte-radegonde',
  '1bbf24f6-47e9-49e6-acce-ee49c487c3e3': '/site/briane-jean-recuperation/ledergues',
  'f151588c-e129-4bfc-be02-69240ed00223': '/site/carmausine-de-recuperation/carmaux',
  '5241f80d-9340-4513-b210-5bc29e1cb54e': '/site/casse-auto-du-bassin/viviez',
  '6276bdc7-5aac-477c-8859-a48b84267d89': '/site/fabrude-recyclage/saint-paul-des-landes',
  'd0e83661-3827-4de3-91b5-24b65fe092f9': '/site/lescout-recyclage/lescout',
  'd6d6fc33-504b-438d-8b93-209e4f218772': '/site/profit-recyclage/beauchamp',
  'f73b630e-b9c6-4e63-b7c6-04af2ff572c3': '/site/rm-recyclage/coren',
};